import {Routes, Route, Navigate} from "react-router-dom";
import App from "./../../App";
import MainPage from "../../pages/main/MainPage";
import FavoriteList from "../../pages/main/favorites/FavoriteList";
import CartList from "../../pages/main/cart/CartList";
import Profile from "../../components/monaliza/profile/Profile";
import Settings from "../../components/monaliza/profile/settings/Settings";
import AuthLayout from "../../pages/authentication/AuthLayout";
import Login from "../../pages/authentication/Login";
import Registration from "./../../pages/authentication/Registration";
import ForgetPassword from "./../../pages/authentication/ForgetPassword";
import Logout from "./../../pages/authentication/Logout";
import ErrorLayout from "./../../pages/error/ErrorLayout";
import Error403 from "../../pages/error/Error403";
import Error404 from "./../../pages/error/Error404";
import Error500 from "./../../pages/error/Error500";
import AdminLayout from "./../../pages/main/admin/AdminLayout";
import ProductLayout from "../../pages/main/product/ProductLayout";
import ProductRegister from "../../pages/main/product/ProductRegister";
import ProductView from './../../pages/main/product/ProductView';
import ProductUpdate from "../../pages/main/product/ProductUpdate";
import Category from "../../pages/main/category/Category";
import Currency from "../../pages/main/currency/Currency";
import MyProductList from "../../pages/main/myProduct/MyProductList";
import AdminList from "../../pages/main/admin/AdminList";
import AdminView from "../../pages/main/admin/AdminView";
import { useEffect } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom"
import { logoutAsync, selectIsAdmin, selectIsOwner } from "../store/reducers/auth/authReducer";
import { useDispatch, useSelector } from 'react-redux';

const AppRoutes = () => {
  const owner = useSelector(selectIsOwner)
  const admin = useSelector(selectIsAdmin)


    
  return (
    <>
      <Routes>
        {/* <Route path="/errors" element={<ErrorLayout/>}>
                    <Route path="/errors/404" element={<Error404/>}/>
                    <Route path="/errors/500" element={<Error500/>}/>
                </Route>
                <Route path="/authentication" element={<AuthLayout/>}>
                    <Route path="/authentication/login" element={<Login/>}/>
                    <Route path="/authentication/registration" element={<Registration/>}/>
                    <Route path="/authentication/forget-password" element={<ForgetPassword/>}/>
                    <Route path="/authentication/logout" element={<Logout/>}/>
                </Route> */}

        <Route path="/" element={<App />}>
          <Route path="/" element={<MainPage />} />
          <Route path="/favorites" element={<FavoriteList />} />
          <Route path="/cart" element={<CartList />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Settings />} />

          <Route path="/errors" element={<ErrorLayout />}>
            <Route path="/errors/403" element={<Error403 />} />
            <Route path="/errors/404" element={<Error404 />} />
            <Route path="/errors/500" element={<Error500 />} />
          </Route>
          <Route path="/authentication" element={<AuthLayout />}>
            <Route path="/authentication/login" element={<Login />} />
            <Route path="/authentication/registration" element={<Registration />} />
            <Route path="/authentication/forget-password" element={<ForgetPassword />} />
            <Route path="/authentication/logout" element={<Logout />} />
          </Route>

          <Route path="/product" element={<ProductLayout/>}>
            <Route path="/product/random/view/:id" element={<ProductView/>} />
            
            {/* {(admin || owner) && */}
              <Route>
                <Route path="/product/my" element={<MyProductList/>} />
                <Route path="/product/view/:id" element={<ProductView/>} />
                <Route path="/product/register" element={<ProductRegister/>} />
                <Route path="/product/update/:id" element={<ProductUpdate/>} />


                <Route path="/product/category" element={<Category/>} />  
                <Route path="/product/currency" element={<Currency/>} />
              </Route>
            {/* } */}
          </Route>

          {admin &&
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="/admin/accounts" element={<AdminList/>} />
              <Route path="/admin/account/:id" element={<AdminView/>} />
            </Route>
          }
        </Route>
        <Route path="*" element={<Navigate to="/errors/404" replace />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
